import React from "react";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { StatusField } from "./components/CustomColumns";
import MobileCard from "../SalesAndMarketing/components/MobileCard";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import { formatRevenue } from "features/Common/utils/common.utils";

const DiscountMobileCard = ({
  record,
  onEdit,
  onDelete,
  onSeeMore,
  columns,
  isAlternate,
}) => {
  const content = columns
    .filter((column) => column.showInCard)
    .map((column) => {
      const value = column.valueFormatter
        ? column.valueFormatter(record)
        : record?.[column.field] ?? column.emptyField ?? "N/A";

      return {
        title: column.headerName,
        value,
      };
    });

  return (
    <MobileCard
      className={isAlternate ? "tw-bg-[#F6F6F6]" : ""}
      header={
        <div className="tw-flex tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center tw-gap-2">
            <LocalOfferOutlinedIcon
              style={{
                fontSize: 24,
                color: "#0000004D",
              }}
            />

            <div className="tw-font-medium tw-text-[16px]">{record.code}</div>
          </div>

          <StatusField record={record} />
        </div>
      }
      content={content}
      stats={[
        {
          title: "Bookings",
          data: record?.total_leads || 0,
          color: "#493AB1",
          icon: "booking.png",
        },
        {
          title: "Revenue",
          data: formatRevenue(record?.total_revenue),
          color: "#1DBE8A",
          icon: "revenue.png",
        },
      ]}
      footer={
        <div className="tw-flex tw-items-center tw-justify-between tw-bg-[#EEECF9] tw-w-full tw-px-4 tw-py-4">
          {/* Left Side Actions */}
          <div className="tw-flex tw-items-center tw-gap-4">
            <DeleteOutlineIcon
              className="tw-cursor-pointer"
              style={{ color: "#D32F2F" }}
              onClick={onDelete}
            />

            <EditIcon
              className="tw-cursor-pointer"
              style={{ color: "#493AB1" }}
              onClick={onEdit}
            />
          </div>

          {/* Right Side See More */}
          <div
            onClick={onSeeMore}
            className="tw-flex tw-items-center tw-gap-1 tw-cursor-pointer"
          >
            <p className="tw-text-[#493AB1] tw-underline tw-m-0">See more</p>

            <ArrowForwardIosIcon
              style={{
                fontSize: 16,
                color: "#493AB1",
              }}
            />
          </div>
        </div>
      }
    />
  );
};

export default DiscountMobileCard;
